import { Box, Paper } from '@material-ui/core'

type SetupProps = {
  children: React.ReactNode
}

export const SetupTile = ({ children }: SetupProps) => {
  return (
    <Paper
      component={Box}
      // @ts-expect-error typing isn't picking up the Box props
      maxWidth="400px"
      width="100%"
      minHeight="415px"
      height="100%"
      p={2}
      elevation={0}
    >
      {children}
    </Paper>
  )
}
